// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__39Gdl","row":"ProcedureTreatmentSummary_row__1rSHo"};